import
{
  StatName,
  SelectContainer,
  ButtonsContainer,
  StatValue,
} from './PrintStatsStat.style';
import { CustomSelect, CustomAutoSelect } from '../../Inputs/CustomSelect/CustomSelect';
import LinkButton from '../../Buttons/LinkButton/LinkButton';
import SectionContainer from '../../Containers/PrintSectionContainer/PrintSectionContainer';
import Grid from '@mui/material/Unstable_Grid2/Grid2';
import { Box, Stack, Typography, Typography as span } from '@mui/material';
import { colors } from '../../../options/colors';

const formatStat = (value) =>
{
  if (value && !isNaN(value))
  {
    return Math.round(value * 100) / 100;
  }
  return '-'
}

const PrintStatsStat = ({ name, desc, stats }) =>
{
  return (
    <Grid
      id="stat"
      container
      spacing={0}
      columns={12}
      sx={{ width: "100%", borderBottom: `1px ${colors.printStatsRed} solid`, paddingTop: "1em" }}
    >
      <Grid xs={6}>
        <StatName>
          {name}
        </StatName>
      </Grid>
      <Grid xs={6} >
        <Stack id="stat2" direction="row" justifyContent="flex-end" spacing={0}  >

          <StatValue color="#000" >
            {formatStat(stats[0])}
          </StatValue>

          {stats[1] &&
            <StatValue sx={{ color: colors.printStatsRed }}>
              /
              {formatStat(stats[1])}
            </StatValue>
          }
          {stats[2] &&
            <StatValue sx={{ color: "grey" }}>
              /
              {formatStat(stats[2])}
            </StatValue>
          }

        </Stack>
      </Grid>
      <Grid xs={10}>
        <Box sx={{ fontSize: "1rem", color: colors.printStatsRed }}  >
          {desc}
        </Box>
      </Grid>
    </Grid>



  );
};

export default PrintStatsStat;
